import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'contentTransport'
})
export class TransportPipe implements PipeTransform {

  private static fixNumber(num) {
    if (num?.includes('#')) {
      num = num.split('#')[0] + parseInt(num.split('#')[1], 10).toString();
    }
    return num;
  }

  private static createConnections(rawConnections: any[]): Models.TrainConnectionEntry[] {
    const now = Date.now() / 1000;

    return rawConnections.filter(item => item.noRides || item.timestamp >= now).map(item => {
      const connection = new Models.TrainConnectionEntry();
      connection.populateFromJSON({
        type: item.type, timestamp: item.timestamp * 1000, track: TransportPipe.fixNumber(item.platform || null),
        line: TransportPipe.fixNumber(item.line), direction: item.direction, noRides: item.noRides || null, stops: item.stops || []
      });
      return connection;
    }).sort((a, b) => a.timestamp - b.timestamp);
  }

  transform(entry: Models.ContentEntry): Models.TrainStationEntry {
    if (!entry?.detail?.departures) {
      return null;
    }
    // todo if we have no departures - handle different then no entry

    const station = new Models.TrainStationEntry();

    station.populateFromJSON({
      sourceId: entry._id, station: entry.detail.station || entry.title,
      departures: TransportPipe.createConnections(entry.detail.departures), arrivals: TransportPipe.createConnections(entry.detail.arrivals)
    });
    return station;
  }
}
